// extracted by mini-css-extract-plugin
module.exports = {"container":"HeroAcademySection_container__ZMC13","hero":"HeroAcademySection_hero__zkgFy"};